import { Register } from "./register"
import { Login } from "./login"
import { GoogleAuthButton } from "./google-auth-button"

export const Account = {
  Register,
  Login,
  GoogleAuthButton
}
